@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  --container-width: 420px;
  --container-gap: 8px;

  --card-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.08);

  display: block;
  z-index: calc(map.get($z-indices, 'modal') + 6);
  position: relative;
}

:host {
  cpsl-overlay {
    z-index: calc(map.get($z-indices, 'modal') + 6);
  }
}

:host(.include-mobile-styling) {
  @media (max-width: 480px) {
    .modal-wrapper {
      scale: none;
      top: 100%;
      left: 0;
      height: unset;
      opacity: 1;
    }

    .modal-container {
      width: 100%;
      max-width: none;

      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }

    .modal-body-card {
      --card-border-radius-bl: 0px;
      --card-border-radius-br: 0px;
    }
  }
}

:host(.force-mobile-media) {
  .modal-wrapper {
    scale: none;
    top: 100%;
    left: 0;
    height: unset;
    opacity: 1;
  }

  .modal-container {
    width: 100%;
    max-width: none;

    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .modal-body-card {
    --card-border-radius-bl: 0px;
    --card-border-radius-br: 0px;
  }
}

:host(.no-overlay) {
  z-index: map.get($z-indices, 'modal-no-overlay');

  & .modal-body-card {
    --card-border-width: 1px;
  }

  & .modal-container {
    max-height: unset;
  }
}

.modal-wrapper {
  z-index: calc(map.get($z-indices, 'modal') + 6);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  scale: 0.8;
  opacity: 0;
  transform: none;
}

.modal-container {
  position: relative;
  overflow: hidden;

  width: var(--container-width);
  display: flex;
  flex-direction: column;
  gap: var(--container-gap);

  max-width: 95vw;
  max-height: 95vh;
  max-height: 95dvh;
  overflow: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  &.no-footer {
    gap: 0px;
  }
}

.modal-body-card {
  --card-padding-top: 16px;
  --card-padding-bottom: 24px;
  --card-padding-start: 24px;
  --card-padding-end: 24px;
  --card-border-width: 0px;
  --card-background-color: var(--cpsl-color-modal-surface-main);
  --card-border-color: var(--cpsl-color-modal-border);
}

#modal-footer {
  --card-background-color: var(--cpsl-color-modal-surface-footer);
}

.body {
  &::part(card-container) {
    box-shadow: var(--card-box-shadow);
    width: 100%;
  }
}

.no-opacity {
  opacity: 0;
}

.mobile-footer {
  margin-top: 16px;
}

.footer-hidden {
  height: 0px;
  visibility: hidden;

  --card-padding-top: 0px;
  --card-padding-bottom: 0px;
  --card-padding-start: 0px;
  --card-padding-end: 0px;
  --card-border-width: 0px;
}
